import axios from 'axios'

import { reatailmediaApi as baseAPI } from '../api'

const baseURL = `${baseAPI}/advertiser`

/**
 * CREATE
 * Cria um novo anunciante
 */
export const createAdvertiserService = (body: CreateAdvertiserPayload) =>
  axios.post<CreateAdvertiserResponse>(`${baseURL}`, body)

/**
 * Upload
 * Faz upload de uma imagem para account info
 */

export const uploadAdvertiserService = ({ body, axiosOptions }) =>
  axios.post<CreateAdvertiserResponse>(`${baseURL}/upload`, body, axiosOptions)

/**
 * LIST
 * Lista anunciantes com filtros opcionais
 */
export const listAdvertiserService = (params: Record<string, unknown> = {}) =>
  axios.get<GetAdvertiserResponse[]>(`${baseURL}`, { params })

/**
 * VIEW
 * Retorna dados do publisher com opção de retornar dados da conta
 */
export const getAdvertiserService = ({
  url: { id },
  params
}: GetAdvertiserResquest) =>
  axios.get<GetAdvertiserResponse>(`${baseURL}/${id}`, { params })
